











































































































































































import Vue from 'vue';
import _ from 'lodash';

import { HistoricoResposta } from '../../../../back/src/entity/HistoricoResposta';
import { HistoricoPergunta } from '../../../../back/src/entity/HistoricoPergunta';

import TheHistoricoRespostaPergunta from './TheHistoricoRespostaPergunta.vue';

export default Vue.extend({
  name: 'TheHistoricoRespostaItem',
  components: {
    TheHistoricoRespostaPergunta,
  },
  props: {
    index: {
      type: Number,
    },
    resposta: {
      type: Object as () => HistoricoResposta,
    },
  },
  data() {
    return {
      edit: false,
      showObservacoes: true,
    };
  },
  computed: {
    pergunta(): HistoricoPergunta {
      return this.resposta.historico_pergunta;
    },
    perguntaObservacoes(): boolean {
      return this.pergunta.opcoes === null;
    },
    perguntaInfo(): boolean {
      if (this.pergunta.opcoes !== null && _.has(this.pergunta.opcoes, '0')) {
        if (this.pergunta.opcoes['0'] !== 'Sim') {
          return true;
        }
        return false;
      }
      return true;
    },
    icon(): string {
      if (this.perguntaInfo) {
        if (this.resposta.resposta === null) {
          return 'fa-fw fa-exclamation';
        }
        return 'fa-fw fa-info-circle';
      }
      if (this.resposta.resposta === '0') {
        return 'fa-fw fa-check-square';
      }
      if (this.resposta.resposta === '1') {
        return 'fa-fw fa-square';
      }
      if (this.resposta.resposta === '2') {
        return 'fa-fw fa-minus-square';
      }
      return 'fa-fw fa-exclamation';
    },
    respostaText(): string {
      if (this.resposta.resposta === null) {
        return 'Não respondida';
      }
      if (_.has(this.pergunta.opcoes, this.resposta.resposta)) {
        return this.pergunta.opcoes[this.resposta.resposta];
      }
      return '';
    },
    color(): string {
      if (this.perguntaObservacoes) {
        if (this.resposta.observacoes) {
          return 'info';
        }
        return 'grey';
      }
      if (this.perguntaInfo) {
        if (this.resposta.resposta === null) {
          return 'warning';
        }
        return 'info';
      }
      if (this.resposta.resposta === '0') {
        return 'info';
      }
      if (this.resposta.resposta === '1') {
        return 'grey';
      }
      if (this.resposta.resposta === '2') {
        return 'secondary';
      }
      return 'warning';
    },
    textColor(): string {
      if (this.perguntaObservacoes) {
        if (this.resposta.observacoes) {
          return 'info--text';
        }
        return 'grey--text';
      }
      if (this.perguntaInfo) {
        if (this.resposta.resposta === null) {
          return 'warning--text';
        }
        return 'info--text';
      }
      if (this.resposta.resposta === '0') {
        return 'info--text';
      }
      if (this.resposta.resposta === '1') {
        return 'grey--text';
      }
      if (this.resposta.resposta === '2') {
        return 'secondary--text';
      }
      return 'warning--text';
    },
  },
});
